<template lang="pug">
  v-card
    .d-flex
      v-btn(@click="close" icon)
        v-icon(size="18") mdi-close-box
      span.pa-2 {{ item.text }}
</template>

<script>
  export default {
    name: "FreespinsGameSimpleCard",
    props: {
      item: {
        type: Object,
        default: function(){
          return {
            text: '',
            value: ''
          }
        }
      },
    },
    methods:{
      close(){
        this.$emit('close', this.item.value);
      },
    },
  }
</script>

<style lang="sass">
</style>